/** Hotkeys we care about when interacting with a dropdown */ export var DropdownHotkey;
(function(DropdownHotkey) {
    DropdownHotkey["ARROW_UP"] = "arrow_up";
    DropdownHotkey["ARROW_DOWN"] = "arrow_down";
    DropdownHotkey["HOME"] = "home";
    DropdownHotkey["END"] = "end";
    DropdownHotkey["ENTER"] = "enter";
    DropdownHotkey["ESCAPE"] = "escape";
    DropdownHotkey["TAB"] = "tab";
    DropdownHotkey["SPACE"] = "space";
    DropdownHotkey["SEARCH"] = "search";
    DropdownHotkey["UNSUPPORTED"] = "unsupported";
})(DropdownHotkey || (DropdownHotkey = {}));
export function keyEventToHotkey(e) {
    switch(e.key){
        case ' ':
        case 'Space':
            return "space";
        case 'Enter':
            return "enter";
        case 'Escape':
            return "escape";
        case 'Tab':
            return "tab";
        case 'ArrowDown':
            return "arrow_down";
        case 'ArrowUp':
            return "arrow_up";
        case 'Home':
            return "home";
        case 'End':
            return "end";
        default:
            if (e.key.match(/^[a-zA-Z0-9]$/)) {
                return "search";
            }
            return "unsupported";
    }
}

//# sourceMappingURL=hotkeys.js.map